import { createStore, Store } from "redux";
import { persistStore, persistReducer, PersistConfig } from "redux-persist";
import storage from "redux-persist/lib/storage";

import { devToolsEnhancer } from "redux-devtools-extension";

import { reducer, State } from "./reducer";
export * from "./reducer";

const persistConfig: PersistConfig = {
  storage,
  key: "root",
  whitelist: ["token"],
};

const persistedReducer = persistReducer(persistConfig, reducer);

export const store: Store<State> = createStore(
  persistedReducer,
  devToolsEnhancer({}),

);
export const persistor = persistStore(store);



// WEBPACK FOOTER //
// ./src/store/index.ts